module.exports = __webpack_public_path__ + "img/bt.53c25d48.png";